@if (data(); as d) {
  <div class="pc" role="alertdialog" data-testid="avia-hold-refused-notice" [attr.aria-labelledby]="titleId">
    <div class="pc-head">
      <h3 class="pc-title" [id]="titleId">{{ 'The flight is not ticketed yet' | translate }}</h3>
      <button
        type="button"
        class="pc-close"
        data-testid="avia-hold-refused-close-button"
        [attr.aria-label]="'Close' | translate"
        (click)="close()"
      >
        ×
      </button>
    </div>
    <div class="pc-body">
      <p class="pc-text" data-testid="avia-hold-refused-message">
        @if (priceChanged()) {
          {{
            'AVIA_HOLD_REFUSED_PRICE_CHANGED'
              | translate
                : {
                    old: (d.hold.oldPrice ?? 0 | priceFormat: d.hold.currency),
                    new: (d.hold.newPrice ?? 0 | priceFormat: d.hold.currency)
                  }
          }}
        } @else {
          {{ 'AVIA_HOLD_REFUSED' | translate }}
        }
      </p>
      @if (rfNumber(); as rf) {
        <div class="pc-table">
          <span class="pc-k">{{ 'Reservation number' | translate }}</span>
          <span class="pc-new" data-testid="avia-hold-refused-rf-number">{{ rf }}</span>
        </div>
      }
      <div class="pc-alert">
        <span class="pc-code" data-testid="avia-hold-refused-code">{{ d.hold.code }}</span>
        <app-avia-trace-id testIdPrefix="avia-hold-refused" [activityId]="d.activityId" />
      </div>
      <div class="pc-actions">
        <button type="button" class="pc-primary" data-testid="avia-hold-refused-ok-button" (click)="close()">
          {{ 'OK' | translate }}
        </button>
      </div>
    </div>
  </div>
}
